import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';

import CustomLink from '../CoustomLink/CustomLink';
import './Header.css'

const Header = () => {
    return (
        <div>
            <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
                <Container>
                    <Navbar.Brand > <span className='teko'>SAREEN</span> - <span>The Melancholia</span></Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">


                        </Nav>
                        <Nav className='text-light'>


                            <CustomLink className='navbar-color' to='/'> Home </CustomLink>
                            <CustomLink className='navbar-color' to='/reviews'> Reviews </CustomLink>
                            <CustomLink className='navbar-color' to='/dashboard'> Dashboard </CustomLink>
                            <CustomLink className='navbar-color' to='/blogs'> Blogs </CustomLink>
                            <CustomLink className='navbar-color' to='/contact'> Contact </CustomLink>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default Header;